define(
    [
        'assets/js/modules/assets',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/design/designFaceModel',
        'assets/js/modules/design/designFaceProcessModel',
        'assets/js/modules/designPreview/dvvPageParamsExtractor'
    ],
    function(assets, OptionValueModel, DesignFaceModel, DesignFaceProcessModel) {
        var SAMPLE_PATH = assets.generate('assets/images/designPreview/designSamples/');
        var WIDTH = 1088;
        var FRONT_SPOT_UV_SAMPLE_NAME = 'front-spotUV.png';
        var BACK_SPOT_UV_SAMPLE_NAME = 'back-spotUV.png';
        // as texture files are similar to spot uv files, use
        // the same for both processes
        var FRONT_TEXTURE_SAMPLE_NAME = 'front-spotUV.png';
        var BACK_TEXTURE_SAMPLE_NAME = 'back-spotUV.png';
        var FRONT_TRI_FOLD_SAMPLE_NAME = 'front-image-tri-fold.png';
        var BACK_TRI_FOLD_SAMPLE_NAME = 'back-image-tri-fold.png';
        var FRONT_Z_FOLD_SAMPLE_NAME = 'front-image-z-fold.png';
        var BACK_Z_FOLD_SAMPLE_NAME = 'back-image-z-fold.png';
        var FRONT_BI_FOLD_SAMPLE_NAME = 'front-image-bi-fold.png';
        var BACK_BI_FOLD_SAMPLE_NAME = 'back-image-bi-fold.png';
        var FRONT_TILE_SAMPLE_NAME = 'front-image-tile.png';
        var BACK_TILE_SAMPLE_NAME = 'back-image-tile.png';

        return {
            getDesignPreviewSample: function(
                productType,
                ratio,
                productSamples,
                hasBack,
                folding,
                uploadPattern,
                frontCoating,
                backCoating
            ) {
                var height = Math.round(WIDTH / ratio);
                var regularProcesses = this.getRegularProcess(productType, folding, uploadPattern, productSamples);

                var frontProcesses = [
                    {
                        type: DesignFaceProcessModel.TYPE_REGULAR,
                        src: regularProcesses.frontImage
                    }
                ];
                var backProcesses = [
                    {
                        type: DesignFaceProcessModel.TYPE_REGULAR,
                        src: hasBack ? regularProcesses.backImage : ''
                    }
                ];

                var frontOptionalProcesses = this.getFrontOptionalProcesses(frontCoating, productType);
                frontProcesses = frontProcesses.concat(frontOptionalProcesses);

                if (hasBack) {
                    var backOptionalProcesses = this.getBackOptionalProcesses(backCoating, productType);
                    backProcesses = backProcesses.concat(backOptionalProcesses);
                }

                return {
                    width: WIDTH,
                    height: height,
                    faces: [
                        {
                            type: DesignFaceModel.TYPE_FRONT,
                            processes: frontProcesses
                        },
                        {
                            type: DesignFaceModel.TYPE_BACK,
                            processes: backProcesses
                        }
                    ]
                };
            },

            /**
             * @param {string} productType
             * @param {string} folding
             * @param {string} uploadPattern
             * @param {backbone.Collection} productSamples
             * @return {object}
             */
            getRegularProcess: function(productType, folding, uploadPattern, productSamples) {
                var frontImage = null;
                var backImage = null;

                if (folding === OptionValueModel.NAME_TRI_FOLD) {
                    frontImage = SAMPLE_PATH + productType + '/' + FRONT_TRI_FOLD_SAMPLE_NAME;
                    backImage = SAMPLE_PATH + productType + '/' + BACK_TRI_FOLD_SAMPLE_NAME;
                } else if (folding === OptionValueModel.NAME_Z_FOLD) {
                    frontImage = SAMPLE_PATH + productType + '/' + FRONT_Z_FOLD_SAMPLE_NAME;
                    backImage = SAMPLE_PATH + productType + '/' + BACK_Z_FOLD_SAMPLE_NAME;
                } else if (folding === OptionValueModel.NAME_BI_FOLD) {
                    frontImage = SAMPLE_PATH + productType + '/' + FRONT_BI_FOLD_SAMPLE_NAME;
                    backImage = SAMPLE_PATH + productType + '/' + BACK_BI_FOLD_SAMPLE_NAME;
                } else if (uploadPattern === OptionValueModel.NAME_UPLOAD_PATTERN_TILE) {
                    frontImage = SAMPLE_PATH + productType + '/' + FRONT_TILE_SAMPLE_NAME;
                    backImage = SAMPLE_PATH + productType + '/' + BACK_TILE_SAMPLE_NAME;
                } else {
                    frontImage = this.getProductSampleByPage(productSamples, 1);
                    backImage = this.getProductSampleByPage(productSamples, 2);
                }

                return {
                    frontImage: frontImage,
                    backImage: backImage
                };
            },

            /**
             * @param {string} coating
             * @param {string} productType
             * @return {Array}
             */
            getFrontOptionalProcesses: function(coating, productType) {
                var processes = [];

                switch (coating) {
                    case OptionValueModel.NAME_FRONT_COATING_SPOT_UV:
                        processes.push({
                            type: DesignFaceProcessModel.TYPE_SPOT_UV,
                            src: SAMPLE_PATH + productType + '/' + FRONT_SPOT_UV_SAMPLE_NAME
                        });
                        break;
                    case OptionValueModel.NAME_FRONT_COATING_TEXTURE:
                        processes.push({
                            type: DesignFaceProcessModel.TYPE_TEXTURE,
                            src: SAMPLE_PATH + productType + '/' + FRONT_TEXTURE_SAMPLE_NAME
                        });
                        break;
                }

                return processes;
            },
            /**
             * @param {string} coating
             * @param {string} productType
             * @return {Array}
             */
            getBackOptionalProcesses: function(coating, productType) {
                var processes = [];

                switch (coating) {
                    case OptionValueModel.NAME_BACK_COATING_SPOT_UV:
                        processes.push({
                            type: DesignFaceProcessModel.TYPE_SPOT_UV,
                            src: SAMPLE_PATH + productType + '/' + BACK_SPOT_UV_SAMPLE_NAME
                        });
                        break;
                    case OptionValueModel.NAME_BACK_COATING_TEXTURE:
                        processes.push({
                            type: DesignFaceProcessModel.TYPE_TEXTURE,
                            src: SAMPLE_PATH + productType + '/' + BACK_TEXTURE_SAMPLE_NAME
                        });
                        break;
                }

                return processes;
            },

            /**
             * @param {backbone.Collection} productSamples
             * @param {number} page
             * @returns {string}
             */
            getProductSampleByPage: function(productSamples, page) {
                var productSample = productSamples.find(function(sample) {
                    return sample.get('page') === page;
                });

                if (productSample !== undefined) {
                    return productSample.get('url');
                }

                return '';
            }
        };
    }
);
